'use strict';
export class AngularLoginConfig {
    appName: string = "Nome applicazione";
    logoImgUrl: string;
    loginButtonText: string = "Accedi";
    message: string;
    waitAttivo : boolean;
    messageAttivo :boolean;
}


// WEBPACK FOOTER //
// ./src/angular_library/models/angular-login-config.ts